import { Imgs } from "../../img/Imgs/Imgs";
import { useEffect, useState } from "react";
import Loader from "../Loader/Loader"; 
import translations from "../../language.json";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
const apiUrl = process.env.REACT_APP_API_URL;

const WebsiteTemplates = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true); 
  const selectedLanguages = useSelector(selectedLanguage);
  
  useEffect(() => {
    const getDatas = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${apiUrl}/alternate-content`);
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    };
    getDatas();
  }, []);
  
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = data.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => setCurrentPage(page);

  return (
    <section className="website-templates">
      <div className="website-templates__container container">
        <h2>{translations[selectedLanguages].templatesMain.websites}</h2>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="invitation-templates-most-watched">
              {currentItems.map((el, index) => (
                <a href={`${el.url}`} key={index} target="_blank" rel="noopener noreferrer">
                  <div className="website-box">
                    <img src={Imgs.laptop_phone} alt="" />
                    <img src={el.image} alt={el.text1} />
                    <img src={el.smallImage} alt={el.text1} />
                  </div>
                  <h3>{el.text1}</h3>
                </a>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="pagintaion">
                {Array.from({ length: totalPages }, (_, i) => (
                  <button key={i} onClick={() => goToPage(i + 1)} className={currentPage === i + 1 ? "active" : ""}>
                    {i + 1}
                  </button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default WebsiteTemplates;
